module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0031-01.jpg"
    }
  })])]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg31lev1"
    }
  }), _vm._v("MARCH")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line2.jpg"
    }
  })])]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg31sec1"
    }
  }), _vm._v("MARCH 1")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have definite artistic tendencies, which should be developed to your good advantage. You have faith in yourself and your ability and will be successful. You are honest, frank, good-natured, and sincere in your affections. You will win a deep and lasting love.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg31sec2"
    }
  }), _vm._v("MARCH 2")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Practice sincerity, patience, and diligence in your ambitions and everyday life. Be less skeptical. You have great self-control and psychic powers and are an excellent conversationalist. You have many friends and prefer "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("the company of the opposite sex but are well liked by your own.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg32sec1"
    }
  }), _vm._v("MARCH 3")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have a magnetic personality, and you should take care that this gift does not lead you into difficulties. You are passionate and your emotions sometimes overpower you, but your love, though fervent, is constant. You like and appreciate music and have some musical ability.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg32sec2"
    }
  }), _vm._v("MARCH 4")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are winning and gracious but somewhat given to criticizing. You are easily influenced, so you should try to be bold, diligent, and faithful. You are a shrewd judge of people and are generally right in your estimate. You are fond of children.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg32sec3"
    }
  }), _vm._v("MARCH 5")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have the gift of farsightedness and are a good planner. All important undertakings should be begun during May and June. You are a true and loyal friend and an ardent lover. You will always be contented and happy.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg33sec1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("MARCH 6")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Don’t marry hastily! With your temperament, an uncongenial mate would make your married life very unhappy. You have a strong will and are self-reliant and inclined to analyze everything. You are fond of sports and excitement. You enjoy having lots of people around you and like making new acquaintances.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg33sec2"
    }
  }), _vm._v("MARCH 7")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You should be more forward; assert yourself. You are slow, methodical, and extremely careful in all you do. Because of your cautious temperament, you are apt not to go through with plans you make. You are generous to a fault and very tenderhearted, and, too often, you allow others to impose upon you.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg33sec3"
    }
  }), _vm._v("MARCH 8")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("With your keen appreciation of good literature and music, you would make a good critic of both. Although you are frank, straightforward, and scrupulously honest, you like personal attention and are apt to seek it. Your love is steadfast and your friendships lasting.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg34sec1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("MARCH 9")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Although you are spiritually inclined, you enjoy outside interests of the higher type. Your home life is very dear to you. You are careful and a good planner, and, as a real leader, you have the faculty of being able to interest others in the things that interest you. You would make a devoted parent.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg34sec2"
    }
  }), _vm._v("MARCH 10")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("With a quick perception and a keen understanding of human nature, you are led by suggestion rather than force. The love and friendships you inspire are true and lasting, and you have no real enemies. You are observing and like to travel, and you will do so extensively.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg34sec3"
    }
  }), _vm._v("MARCH 11")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("In adversity, you are spurred on, rather than discouraged. You are an ardent lover and the bitterest enemy. Never halfway in your work or social life, you are enthusiastic in whatever you undertake.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg34sec4"
    }
  }), _vm._v("MARCH 12")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have a friendly and engaging personality, and you form many lasting friendships. You should let your gift "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("of intuition guide you, as it is more accurate than your carefully drawn conclusions. You are impulsive in love but honest and faithful.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg35sec1"
    }
  }), _vm._v("MARCH 13")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Let the success of your many ambitions make you happy, and forget past failures. Study yourself and develop all your latent talents. You make friends easily and have many loyal and true ones.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg35sec2"
    }
  }), _vm._v("MARCH 14")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are fond of society and a good conversationalist, and your company is sought by all. You are energetic and a clear thinker. With your blessed combination of ambition and a friendly disposition, you should achieve great success in anything you undertake.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg35sec3"
    }
  }), _vm._v("MARCH 15")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Modest and unassuming, you nevertheless have a strong personality that enables you to take a leading part in all you do. You have the entire confidence of your friends and associates, and your love is wholehearted and sincere.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg36sec1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("MARCH 16")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Your serious nature is known by only your most intimate friends, because you cover it with a blithe and happy-go-lucky disposition. Any unhappiness is kept to yourself, and you are kind without needing attention for it. You can command a great love and will be very happy.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg36sec2"
    }
  }), _vm._v("MARCH 17")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are retiring, thoughtful, and rather philosophical, and you have definite opinions. You do not invite the advances of others, and, when you receive them, you are indifferent. Those who are fortunate enough to gain your confidence are true and loyal friends.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg36sec3"
    }
  }), _vm._v("MARCH 18")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Cultivate your self-confidence and be less restless and anxious; you have ability. You love your home life, and your circle of friends, though small, is a strong force in your life. You will always be happy.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg36sec4"
    }
  }), _vm._v("MARCH 19")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are domestic, kind, extremely generous, gentle, and sensitive. If you are not in harmonious surroundings, you "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("are completely miserable. You need an unusual amount of love and understanding. Your sweet and adoring disposition will undoubtedly or probably win this affection.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg37sec1"
    }
  }), _vm._v("MARCH 20")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are studious, intellectual, and a logical thinker. You are fond of travel and gaiety, and your retrospective tendency makes your pleasures and observations permanent. You will love deeply, work diligently, and play with childlike abandon.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg37sec2"
    }
  }), _vm._v("MARCH 21")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are impetuous, persistent, and somewhat stubborn. You are kind and loving in your marital relations, and, if you cause any unhappiness by your impatience, you are quick to make amends. You are a leader and are sincere in all things and with all people.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg37sec3"
    }
  }), _vm._v("MARCH 22")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have a very friendly disposition and are liked by everyone. You are happy and fond of pleasure, but, when working, you concentrate all your efforts and turn out a job well done. You are sincere and generous in your love.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg38sec1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("MARCH 23")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("A good executive and meticulous about detail, you are a born leader in business and in your social life. You are considerate of others and friendly. You will have a happy married life with many children.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg38sec2"
    }
  }), _vm._v("MARCH 24")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are naturally industrious and self-sufficient. For those you love, you will exert all your energies toward making them happy. You are very affectionate, especially intuitive, and somewhat psychic.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg38sec3"
    }
  }), _vm._v("MARCH 25")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Through your openhearted, generous nature, you will make many real friends and a happy marriage. You are careful and thrifty, and you will follow the plans you make for your future with care and precision to a successful conclusion.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg38sec4"
    }
  }), _vm._v("MARCH 26")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are very positive in your opinions and dislike opposition, which is apt to make you bitter. You are generous, but you will not allow imposition. You do not invite "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("advances and are rather shy, but, when you do yield, you will love with a deep, overpowering passion.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg39sec1"
    }
  }), _vm._v("MARCH 27")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Originality, courage, and a keen sense of humor are your chief characteristics. You love good times and like to share them. You are naturally friendly and enjoy a large circle of friends.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg39sec2"
    }
  }), _vm._v("MARCH 28")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Positive and aggressive, you enjoy having people around you. People born on this day are fortunate and successful in business. You are also a good manager, both at home and at work.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg39sec3"
    }
  }), _vm._v("MARCH 29")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are affectionate and love with wholeheartedness and sincerity, but you should not let your heart rule your head. You are sensitive and romantic. Cultivate more self-confidence; you have great ability and could be a leader if you had greater self-esteem.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg40sec1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("MARCH 30")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are analytical and give a great deal of thought and careful consideration to a problem before doing anything important. Be less skeptical in your opinion of others. You are loving and will have a happy home life.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg40sec2"
    }
  }), _vm._v("MARCH 31")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are intellectual, kindhearted, and loving. You enjoy music and have quite an artistic temperament. Women born on this day make devoted wives and excellent mothers and are the very nucleus of the home.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e0170e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09-chapter03.vue
// module id = 81
// module chunks = 0